import React, { Component } from 'react';

import './ServiceRequestDetails.scss';
import Diagnosis from '../../components/Diagnosis/Diagnosis';
import Row from '../../components/Row';
import Col from '../../components/Col';
import Loader from '../../components/Loader';
import { BrandingContext } from '../../branding/BrandingContextProvider';



class ServiceRequestDetails extends Component {
  static contextType = BrandingContext;
  render() {
    const { serviceRequest } = this.props;
    const tags = serviceRequest.tags && serviceRequest.tags.length > 0 ? serviceRequest.tags : [];
    let tagNames = [];
    if(tags.length > 0) {
        tags.map(tag => tagNames = [...tagNames, tag?.name]);
    }   
    const { branding } = this.context; 

    const changeServiceRequest = (text) => {
      if(text !== 'Service Request') return text;
      return branding.text.serviceRequest;
    }
    return(
      <div className="serviceRequestDetails">
        <Diagnosis
          asset={serviceRequest.asset.item.name}
          issueType={serviceRequest.issueType.name}
          location={serviceRequest.asset?.name}
          expiresAt={ serviceRequest.asset.warrantDays < 60 ?  serviceRequest.asset.warrantyExpiresAt : null}
        />
        <Row>
          <Col
            xs={6}
          >
            <strong>{changeServiceRequest(serviceRequest.subject)}</strong><br />
            {serviceRequest.description} 
          </Col>
          <Col
            xs={6}
          >
            <strong>Serial Number</strong><br />
            {serviceRequest.asset.serialNumber}
          </Col>
        </Row>
        <br />
        {tagNames && tagNames.length > 0 &&
        <Row>
          <Col
            xs={12}
          >
            <strong>Tags: </strong> {tagNames.join(', ')}
          </Col>
        </Row>}
        <br />
      </div>
    );
  }
}

export default ServiceRequestDetails;
